module.exports = __webpack_public_path__ + "img/EagleGlobalMarkets-logo.431e4f47.svg";